import React, { useContext } from 'react';
import type { MenuProps } from 'antd';
import { Button, Dropdown } from 'antd';
import { AppContext } from '@/context'



const App: React.FC = () => {
  const { setLanguage } = useContext(AppContext)

  const change = (index: number) => {
    index == 1 ? setLanguage('English') : setLanguage('Chinese')
  }

  const items: MenuProps['items'] = [
    {
      key: '1',
      label: (
        <div style={{ padding: '0 10px' }} onClick={() => change(1)}>English</div>
      ),
    },
    {
      key: '2',
      label: (
        <div style={{ padding: '0 10px' }} onClick={() => change(2)}>中文</div>
      ),
    },

  ];

  return (
    <>
      <Dropdown menu={{ items }} placement="bottom" arrow>
        <div style={{ marginRight: 10 }}>
          <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5063" width="26" height="26"><path d="M947.925 512.42c0-238.265-192.118-432.19-429.575-435.615-1.43-0.062-2.739-0.311-4.172-0.311-0.311 0-0.56 0.062-0.872 0.062-0.434 0-0.872-0.062-1.307-0.062-240.381 0-435.925 195.544-435.925 435.926 0 240.38 195.544 435.927 435.926 435.927 0.434 0 0.872-0.065 1.308-0.065 0.31 0 0.56 0.065 0.872 0.065 1.432 0 2.741-0.314 4.172-0.314 237.455-3.423 429.573-197.349 429.573-435.613z m-185.393-30.08c-1.682-52.622-7.535-101.882-17.561-146.346 28.334-8.719 54.116-19.18 77.468-31.262 34.627 51.563 56.423 112.281 61.716 177.608H762.532z m-62.212 0H543.138V366.758c50.194-1.557 97.646-6.85 141.177-15.693 8.842 39.793 14.386 83.884 16.005 131.275zM543.138 304.483V143.128c52.745 14.448 96.337 68.004 124.24 147.716-38.424 7.473-80.214 12.144-124.24 13.639z m-62.276-160.171v160.17c-42.47-1.432-82.825-5.853-120.19-12.89 27.151-77.969 69.249-131.089 120.19-147.28z m0 222.446v115.644H328.04c1.619-47.08 7.038-90.858 15.756-130.466 42.471 8.283 88.43 13.327 137.067 14.822zM265.826 482.34h-125.92c5.232-65.327 27.09-125.982 61.653-177.608 24.474 12.641 51.626 23.665 81.518 32.57-9.778 44.153-15.569 92.977-17.251 145.038z m0.063 62.274c1.805 52.125 7.721 100.826 17.685 144.918-29.642 8.842-56.67 19.677-80.957 32.132-34.811-51.377-56.982-111.846-62.587-177.05h125.86z m62.212 0h152.823v115.647c-48.449 1.495-94.284 6.476-136.568 14.76-8.906-39.547-14.51-83.263-16.255-130.407z m152.761 177.922V880.53c-50.504-16.066-92.29-68.442-119.506-145.225 37.18-6.977 77.347-11.336 119.506-12.768z m62.276 159.237V722.536c43.715 1.495 85.256 6.104 123.49 13.515-27.898 78.589-71.18 131.337-123.49 145.722z m0-221.512V544.614h157.12c-1.744 47.394-7.474 91.42-16.38 131.217-43.466-8.72-90.672-14.013-140.74-15.57zM762.47 544.614h121.562c-5.606 65.142-27.776 125.672-62.588 176.988-23.167-11.894-48.824-22.295-76.91-30.89 10.09-44.339 16.131-93.473 17.936-146.098z m19.865-289.39c-16.627 7.784-34.874 14.634-54.49 20.674-12.33-36.243-27.588-68.315-45.524-95.654a374.64 374.64 0 0 1 100.014 74.98z m-434.368-77.97c-18.994 28.211-35.06 61.84-47.89 99.952-21.173-6.352-40.665-13.7-58.413-21.983 30.39-31.947 66.323-58.352 106.303-77.969z m-104.871 593.92c17.562-8.096 36.805-15.384 57.667-21.611 12.767 37.301 28.584 70.246 47.204 98.022-39.357-19.306-74.792-45.15-104.871-76.411z m439.226 73.423c17.562-26.842 32.634-58.229 44.837-93.726 19.307 5.915 37.305 12.702 53.747 20.302-28.463 29.644-61.717 54.428-98.584 73.424z" p-id="5064" fill="#bfbfbf"></path></svg>
        </div>

        {/* <img src={getImage('lang.png')} width='24px' height='24px' style={{ marginRight: '10px' }} /> */}
      </Dropdown>
    </>
  )
}

export default App;